export const ACCOUNTS_CREATE_EDIT_ACCOUNT_OPEN_MODAL = "ACCOUNTS_CREATE_EDIT_ACCOUNT_OPEN_MODAL";
export const ACCOUNTS_CREATE_EDIT_ACCOUNT_CLOSE_MODAL = "ACCOUNTS_CREATE_EDIT_ACCOUNT_CLOSE_MODAL";
export const ACCOUNTS_CREATE_ACCOUNT_REQUEST = "ACCOUNTS_CREATE_ACCOUNT_REQUEST";
export const ACCOUNTS_CREATE_ACCOUNT_RESULT = "ACCOUNTS_CREATE_ACCOUNT_RESULT";
export const ACCOUNTS_EDIT_ACCOUNT_REQUEST = "ACCOUNTS_EDIT_ACCOUNT_REQUEST";
export const ACCOUNTS_EDIT_ACCOUNT_RESULT = "ACCOUNTS_EDIT_ACCOUNT_RESULT";

export const ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_ROLES_REQUEST = "ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_ROLES_REQUEST";
export const ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_ROLES_RESULT = "ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_ROLES_RESULT";

export const ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_REQUEST = "ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_REQUEST";
export const ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_RESULT = "ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_RESULT";

export const ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ACCOUNT_REQUEST = "ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ACCOUNT_REQUEST";
export const ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ACCOUNT_RESULT = "ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ACCOUNT_RESULT";

export const ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_CUSTOM_ROLE_REQUEST = "ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_CUSTOM_ROLE_REQUEST";
export const ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_CUSTOM_ROLE_RESULT = "ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_CUSTOM_ROLE_RESULT";

export const ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_MODULES_TEMPLATE_REQUEST = "ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_MODULES_TEMPLATE_REQUEST";
export const ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_MODULES_TEMPLATE_RESULT = "ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_MODULES_TEMPLATE_RESULT";

export const ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_TIMEZONES_REQUEST = "ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_TIMEZONES_REQUEST";
export const ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_TIMEZONES_RESULT = "ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_TIMEZONES_RESULT";

export const ACCOUNTS_CREDENCIAL_VALIDATION_REQUEST = "ACCOUNTS_CREDENCIAL_VALIDATION_REQUEST";
export const ACCOUNTS_CREDENCIAL_VALIDATION_RESULT = "ACCOUNTS_CREDENCIAL_VALIDATION_RESULT";


